function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85 35.661a5 5 0 0 1-5-5V10H59.339a5 5 0 1 1 0-10H85a5 5 0 0 1 5 5v25.661a5 5 0 0 1-5 5z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#000",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(2.81 0 0 2.81 1.407 1.407)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.678 61.322a4.998 4.998 0 0 1-3.536-8.535L81.465 1.464a5 5 0 0 1 7.07 7.071L37.214 59.857a4.984 4.984 0 0 1-3.536 1.465z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#000",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(2.81 0 0 2.81 1.407 1.407)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.394 90H15.606C7.001 90 0 82.999 0 74.394V15.606C0 7.001 7.001 0 15.606 0h18.072a5 5 0 0 1 0 10H15.606A5.613 5.613 0 0 0 10 15.606v58.787A5.613 5.613 0 0 0 15.606 80h58.787A5.613 5.613 0 0 0 80 74.394V56.322c0-2.762 2.238-5 5-5s5 2.238 5 5v18.071C90 82.999 82.999 90 74.394 90z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#000",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(2.81 0 0 2.81 1.407 1.407)"
  })));
};
export default SvgShare;